import { react2angular } from 'react2angular';

import app from '../../../../browser/addform/scripts/app';
import { withProvider } from '../../../redux';
import { FilterBusinessAppointments } from './FilterBusinessAppointments';

app.component(
  'filterBusinessAppointments',
  react2angular(withProvider(FilterBusinessAppointments), ['onSelect', 'onBlur'], ['config', 'httpApi', 'logger']),
);
